import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserService } from '../../../../services/user.service'
import { ManagePukalService } from '../../../../services/manage-pukal.service';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'dialog-fedgov-exporttoftp',
    templateUrl: 'dialog.exporttoftp.html',
    styleUrls: ['dialog.exporttoftp.css']
})
export class ExportFTPFederalGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    janExportNewPukalAccounts = [];
    janExportTerminatedPukalAccounts = [];
    enabledBtnDownload: boolean = false;
    isDownload: boolean = false;
    janEncryption: boolean = true;
    errorMessage: string = '';

    constructor(public dialogRef: MatDialogRef<ExportFTPFederalGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: UserService,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        let acc_off_sub = this.managePukalService.getJANExportPukalAccount()
            .subscribe(
                (data) => {
                    this.janExportNewPukalAccounts = data.JANExportNewPukalAccounts;
                    this.janExportTerminatedPukalAccounts = data.JANExportTerminatedPukalAccounts;
                    this.enabledBtnDownload = data.enabledBtnDownload;
                },
                error => this.errorMessage = <any>error
            );

        // Adds into array for each subscribe
        this.allSub.push(acc_off_sub);
    }

    downloadPtj() {
        let cfm = confirm("Are you sure you want to download the PTJ Account Files?");

        if (cfm) {
            this.isDownload = true;

            let sub = this.managePukalService.downloadPtjAccountFiles(this.janEncryption, 'JA')
                .subscribe(
                    (data) => {
                        if (data.status === 204) {
                            this.isDownload = false;
                            this.openSnackBar('Download failed.', '');
                        } else if (data.status === 200) {
                            let blob = new Blob([data.body], { type: 'application/zip' });
                            saveAs(blob, 'PTJ Account.zip');

                            this.isDownload = false;
                            this.dialogRef.close('Download successful');
                        } else {
                            this.isDownload = false;
                            this.openSnackBar('Download failed.', '');
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.isDownload = false;
                        this.openSnackBar(this.errorMessage, '');
                    });

            // Adds into array for each subscribe
            this.allSub.push(sub);
        }
    }

    cbOnChange(e) {
        this.janEncryption = e.checked;
    }

    closeDialog(): void {
        this.dialogRef.close('Close');
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}